class Project {
    constructor(server_project_id = NaN, name = "", address = "", notes = "", floorplans = {}) {
        this.server_project_id = server_project_id;
        this.name = name;
        this.address = address;
        this.notes = notes;
        this.floorplans = floorplans;
    }
}

export default Project;